var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "LoadingSync",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M46.88,30.9a1.74,1.74,0,0,0-1.25-.52h0a1.78,1.78,0,0,0-1.77,1.81,13.74,13.74,0,0,1-.24,2.27A11.25,11.25,0,0,1,36,43.18,11.24,11.24,0,0,1,24.51,41l-.22-.22h3.08a1.79,1.79,0,1,0,0-3.58H20A1.77,1.77,0,0,0,18.17,39v.16c0,2.4,0,4.79,0,7.19a2.22,2.22,0,0,0,.25,1,1.69,1.69,0,0,0,1.51.88,1.85,1.85,0,0,0,.46-.06,1.77,1.77,0,0,0,1.35-1.71c0-.78,0-1.55,0-2.33v-.83l.14.12a14.91,14.91,0,0,0,9.64,3.93A14.77,14.77,0,0,0,43.2,42.61a14.94,14.94,0,0,0,4.18-10.37A1.84,1.84,0,0,0,46.88,30.9Z"/>
    <path d="M18.38,33.62a1.78,1.78,0,0,0,1.77-1.81,13.76,13.76,0,0,1,.24-2.27A11.24,11.24,0,0,1,28,20.82,11.24,11.24,0,0,1,39.49,23l.22.22H36.63a1.74,1.74,0,0,0-1.39.63,1.78,1.78,0,0,0,1.43,2.95H44A1.77,1.77,0,0,0,45.83,25v-.16c0-2.4,0-4.8,0-7.19a2.23,2.23,0,0,0-.25-1,1.72,1.72,0,0,0-2-.82,1.77,1.77,0,0,0-1.35,1.71c0,.78,0,1.55,0,2.33v.83h0l-.13-.11a15.24,15.24,0,0,0-21.31.83,14.94,14.94,0,0,0-4.18,10.37,1.84,1.84,0,0,0,.51,1.33,1.74,1.74,0,0,0,1.25.52Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/loading_sync.svg